import LogoFull from "assets/logo-full.png";

function Header() {
  return (
    <div className="h-16 w-screen bg-[#F7E2E2] px-3 md:px-10 flex items-center justify-between fixed z-50">
      <img
        alt="logo"
        src={LogoFull}
        className=" h-14 object-contain drop-shadow-lg"
      />
      <div>
          <button className="h-10 border-pink-400 border-4 bg-[#1A132F] w-32 rounded-[40px] hover:shadow-xl hover:mt-[2px] relative z-10">
              <span className="text-white font-exo font-semibold">Admin</span>
          </button>
      </div>
    </div>
  );
}

export default Header;
